export default class Collapsible {
    constructor($wrapper) {
        this.$trigger = $wrapper.querySelector('[data-collapsible-trigger]');
        this.$content = $wrapper.querySelector('[data-collapsible-content]');
        this.$body = $wrapper.querySelector('[data-collapsible-body]');
        this.$wrapper = $wrapper;

        this.toggle = this.toggle.bind(this);
        this.setBodyMaxHeight = this.setBodyMaxHeight.bind(this);

        this.$trigger.addEventListener('click', this.toggle);
        window.addEventListener('resize', this.setBodyMaxHeight);
        $wrapper.addEventListener('resize-content', () => {
            this.setBodyMaxHeight(false)
        });

        if(this.$body) {
            this.setBodyMaxHeight();
        }
    }

    setBodyMaxHeight(delay = true) {
        // add timeout beceause content takes some time to render when we use the toon meer/minder
        if(this.$body) {
            setTimeout(() => {
                this.$content.style.setProperty('--max-height', this.$body.offsetHeight + 'px');
            }, delay ? 700 : 50);
        }
    }

    toggle(e) {
        if(e) {
            e.preventDefault();
        }

        this.$trigger.classList.toggle('collapsible__trigger--active');
        this.$content.classList.toggle('collapsible__content--active');

        this.$wrapper.dispatchEvent(new CustomEvent('toggle-collapsible'));
    }
}